import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
type ButtonWithCountContainerProps = {
  children: ReactNode;
};
export function ButtonWithCountContainer(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="mx-auto mt-8 flex w-fit flex-col items-center gap-2">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}